import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ChangeDetectorRef, Input, ViewChild } from '@angular/core';
//import { DragulaService } from 'ng2-dragula';
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ColumnItemComponent } from './column-item/column-item.component';
import { DataQueryButtonDataConfigComponent } from '../../data-query-button-data-config.component';
import { ValueFormatter } from '../../../../../../../../common/components/data-table/formatters/data-table.formatters';

import { QueryService } from '../../../../../../../../common/services/query.service';
import { DialogService } from '../../../../../../../../common/services/dialog.service';

import { Column, ObjectProperties } from '../../../../../../../../common/components/data-table/models/column.interface';
import { DataQuery } from '../../../../../../../../common/models/query.model';

@Component({
    selector: 'column-mapper',
    templateUrl: './column-mapper.component.html',
    styleUrls: ['./column-mapper.component.scss'],
    standalone: false
})
export class ColumnMapperComponent implements OnInit, AfterViewInit {

  @Input() public componentData: any;
  @Input() public flattenArrayProperties: boolean = true;
  @Input() public generateArrayProperties: boolean = false;

  @ViewChildren(ColumnItemComponent) public _itemViews: QueryList<ColumnItemComponent>;
  @ViewChild(DataQueryButtonDataConfigComponent, { static: true }) public _dataQueryConfig: DataQueryButtonDataConfigComponent;

  public selectedQuery: DataQuery;
  public clickedQuery: DataQuery;
  //TODO: make a properties crawler options object?
  public selectedObject: ObjectProperties[];

  constructor(
    //public _dragulaService: DragulaService,
    public _changeDetectorRef: ChangeDetectorRef,
    public _queryService: QueryService,
    public dialogService: DialogService,
  ) {
	  //this._dragulaService.createGroup("column-mapper", {});
  }

  ngOnInit() {
    this.selectedQuery = this.componentData.config.query;
    if (this.selectedQuery)
      this._populateObject();
    if (!this.componentData.config.columns)
      this.componentData.config.columns = [];
  }

  ngAfterViewInit() {
	  //this._dragulaService.drop("column-mapper").subscribe((result) => {
   //   this.onDrop();
   // });
    this._dataQueryConfig.onParamChanged.subscribe((result) => {
      this._populateObject();
    });
  }

  public addColumn(e?: MouseEvent): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
    var subscription = this._itemViews.changes.subscribe((result: QueryList<ColumnItemComponent>) => {
      result.last.toggleEdit();
      subscription.unsubscribe();
    });
    this.componentData.config.columns.push({
      name: this.componentData.config.columns.length + 1,
      index: this.componentData.config.columns.length + 1,
      renderer: 'default',
      valueFormatter: ValueFormatter.None,
      formatterOptions: {
        params: {}
      }
    } as Column);
    this._changeDetectorRef.detectChanges();
  }

  public onDrop(event: CdkDragDrop<any>): void {
    //let idx = 0;
	  //this.componentData.config.columns.forEach(x => x.index = ++idx);
	  moveItemInArray(this.componentData.config.columns, event.previousIndex, event.currentIndex);
  }

  public removeColumn(val: Column): void {
    let index = this.componentData.config.columns.findIndex(x => x === val);
    if (index === -1)
      return;
    this.componentData.config.columns.splice(index, 1);
    while (index < this.componentData.config.columns.length)
      this.componentData.config.columns[index].index = ++index;
  }

  public selectQuery(query: DataQuery): any {
    this.clickedQuery = query;
    if (this.selectedQuery === query)
      return;
    if (this.componentData.config.columns.length === 0) {
      this.componentData.config.query = query;
      this.selectedQuery = query;
      this._populateObject();
      return;
    }
    this.dialogService.openDialog('confirmCancel', 'This change will delete created columns.');
  }

  public _populateObject(): void {
    this.selectedObject = null;
    if (this.selectedQuery.id === '-1')
      return;
    this._queryService.runQuery(this.selectedQuery).subscribe((result) => {
      if (!result) return;
      this.selectedObject = this._parseObject(result[0]);
      this._changeDetectorRef.detectChanges();
    });
  }

  public _parseObject(obj: Object, parent: ObjectProperties = { name: '', content: [], path: '$', type: 'object' }): ObjectProperties[] {
    for (let prop in obj) {
      if (prop.charAt(0) === '_')
        continue;
      let propertyObj: ObjectProperties = { name: prop, path: `${parent.path}`, content: [], type: typeof obj[prop] };
      if (obj[prop] instanceof Array) {
        if (this.flattenArrayProperties) {
          propertyObj.path += `.${prop}`;
          if (this.generateArrayProperties) {
            propertyObj.path += '[*]';
            propertyObj.content = this._parseObject(obj[prop][0], propertyObj);
            propertyObj.content[0].path = propertyObj.path;
          }
          else
            propertyObj.content = [];

          parent.content.push(propertyObj);
        }
        else {
          propertyObj.path += `[${prop}]`;
          propertyObj.content = this._parseObject(obj[prop], propertyObj);
          parent.content.push(propertyObj);
        }
      }
      else if (obj[prop] instanceof Object) {
        propertyObj.path += `.${prop}`;
        propertyObj.content = this._parseObject(obj[prop], propertyObj);
        parent.content.push(propertyObj);
      } else {
        propertyObj.path += `.${prop}`
        parent.content.push(propertyObj);
      }
    }
    return parent.content;
  }

  public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    this.componentData.config.query = this.clickedQuery;
    this.componentData.config.columns = [];
    this.selectedQuery = this.clickedQuery;
    this._populateObject();
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
    this._dataQueryConfig.selectedQueryId = this.selectedQuery.id;
    this._dataQueryConfig.selectedQueryChanged();
  }

}
